export const CLOCK_ICON = `
<svg
  viewBox="0 0 45 45"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  aria-hidden="true"
  focusable="false"
>
  <path
    d="M22.25 8C23.4926 8 24.5 9.00736 24.5 10.25V20.6094L28.2441 18.7373C29.3555 18.1819 30.707 18.6328 31.2627 19.7441C31.8181 20.8555 31.3672 22.207 30.2559 22.7627L24.7031 25.5391C22.5423 26.6192 20 25.0477 20 22.6318V10.25C20 9.00736 21.0074 8 22.25 8Z"
    fill="currentColor"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M22.25 0C34.5383 -2.6857e-07 44.5 9.96166 44.5 22.25C44.5 34.5383 34.5383 44.5 22.25 44.5C9.96166 44.5 2.6857e-07 34.5383 0 22.25C-2.6857e-07 9.96166 9.96166 2.6857e-07 22.25 0ZM22.25 4.5C12.4469 4.5 4.5 12.4469 4.5 22.25C4.5 32.0531 12.4469 40 22.25 40C32.0531 40 40 32.0531 40 22.25C40 12.4469 32.0531 4.5 22.25 4.5Z"
    fill="currentColor"
  />
</svg>
`;
